var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#474A60",
    d: "M4 11a2 2 0 0 1 2-2h21a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M9.802 13l1.54 3.652L12.891 13h1.802l-2.69 6h-1.32L8 13h1.802zM17.915 13v6h-1.658v-6h1.658zM21.801 15.753h.55c.61 0 .914-.249.914-.748 0-.498-.304-.748-.914-.748h-.55v1.496zm0 3.247h-1.658v-6h2.64c.716 0 1.264.175 1.642.525.383.35.575.844.575 1.48 0 .637-.192 1.13-.575 1.48-.378.35-.926.526-1.642.526h-.982V19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipIcon);
export default __webpack_public_path__ + "static/media/vip_icon.bf546ffd76c330012da00b87608b0b67.svg";
export { ForwardRef as ReactComponent };